import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../../validations/date-text-field.validator'
import { DrugPlan } from '../../models/drug-plan'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { PlanList } from '../../models/plan-list'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { EthnicityData } from '../../models/ethnicity-data';
import { RaceData } from '../../models/race-data';

@Component({
    selector: 'raceethnicity',
    templateUrl: 'race-ethnicity.component.html',
    styleUrls: ['race-ethnicit.component.scss']
})

export class RaceEthnicityComponent implements OnInit {
    @Input() disabled: boolean = false
    // @Input() drugPlan: DrugPlan
    @Output() onValueChange: EventEmitter<DrugPlan> = new EventEmitter<DrugPlan>()
    notBlankValidator = new NotBlankGenericFieldValidator()
    validatedDate = new DateTextFieldValidator()
    isValidAgent: boolean
    planYear: number
    public optionrbPlan: ValidatedRadioButtonModel[] = []
    planList: PlanList[] = [] as PlanList[]
    selPlan: string
    AppDate: Date
    EffectiveDate: Date
    formValue: string
    spnyouthey: string
    spnyourhisher: string
    spnYourTheir: string
    AgentFullName: string
    enrol: EnrollmentViewModel = {} as EnrollmentViewModel
    @Input() enrollmentRaceEthnicityViewModel: EnrollmentViewModel
    @Input() isSpanish: boolean
    @Input() AgentOrgID: Number
    raceList: RaceData[] = [] as RaceData[]
    raceListDM46: RaceData[] = [] as RaceData[]
    ethnicityList: EthnicityData[] = [] as EthnicityData[]

    constructor(private _enrollmentGateway: EnrollmentGateway) {
    }


    ngOnInit() {

        this.loadData();
        this.phoneEnrollmentData();
    }

    loadData() {
        this._enrollmentGateway.getRaceData()
            .subscribe(
                (model: RaceData[]) => {
                    this.raceList = model

                    if (this.enrollmentRaceEthnicityViewModel.Race !== undefined && this.enrollmentRaceEthnicityViewModel.Race !== '') {
                        var race = this.enrollmentRaceEthnicityViewModel.Race.split('');
                        this.raceList.sort((a, b) => (
                            a.DM46Position - b.DM46Position
                            // your sort logic
                            // a.Id - b.Id // example : order by id
                        ));
                        race.forEach((element, index) => {
                            if (element == 'Y') {
                                this.raceList[index].IsChecked = true
                            }
                            else {
                                this.raceList[index].IsChecked = false
                            }
                        });

                        this.raceList.sort((a, b) => (
                            a.Sequence - b.Sequence
                            // your sort logic
                            // a.Id - b.Id // example : order by id
                        ));
                    }
                    else {
                        this.raceList.forEach((element, index) => {
                            this.enrollmentRaceEthnicityViewModel.Race =
                                (this.enrollmentRaceEthnicityViewModel.Race == undefined || this.enrollmentRaceEthnicityViewModel.Race == '') ? 'N' : this.enrollmentRaceEthnicityViewModel.Race + 'N'
                        });

                    }
                }
            )
        this._enrollmentGateway.getEthnicityData()
            .subscribe(
                (model: EthnicityData[]) => {
                    this.ethnicityList = model

                    if (this.enrollmentRaceEthnicityViewModel.Ethnicity !== undefined && this.enrollmentRaceEthnicityViewModel.Ethnicity !== '') {
                        var ethnicity = this.enrollmentRaceEthnicityViewModel.Ethnicity.split('');
                        this.ethnicityList.sort((a, b) => (
                            a.DM46Position - b.DM46Position
                        ));
                        ethnicity.forEach((element, index) => {
                            if (element == 'Y') {
                                this.ethnicityList[index].IsChecked = true
                            }
                            else {
                                this.ethnicityList[index].IsChecked = false
                            }
                        });

                        this.ethnicityList.sort((a, b) => (
                            a.Sequence - b.Sequence
                        ));
                    }
                    else {
                        this.ethnicityList.forEach((element, index) => {
                            this.enrollmentRaceEthnicityViewModel.Ethnicity =
                                (this.enrollmentRaceEthnicityViewModel.Ethnicity == undefined || this.enrollmentRaceEthnicityViewModel.Ethnicity == '') ? 'N' : this.enrollmentRaceEthnicityViewModel.Ethnicity + 'N'
                        });

                    }
                }
            )
      
    }

    phoneEnrollmentData() {

        this.enrol = this._enrollmentGateway.getEnrollmentViewModel();
        if (this.enrol != undefined && this.enrol.isPhoneEnrollment) {
            this.AgentFullName = this.enrol.APPFN + ' ' + this.enrol.APPLN

            if (this.enrol.RBLBENFE === 'Yes') { 
                this.spnyourhisher = 'your' 
                this.spnyouthey = 'you'
                this.spnYourTheir = 'your '
            }
            if (this.enrol.RBLBENFE === 'No' && this.AgentFullName !== " " && this.AgentFullName !== 'undefined undefined') { 
                if (this.enrol.TITLE === 'Mr' || this.enrol.APPGEN === 'M') { 
                    this.spnyourhisher = 'his' 
                    this.spnyouthey = 'they'
                }
                else if (this.enrol.TITLE === 'Mrs' || this.enrol.TITLE === 'Ms' || this.enrol.APPGEN === 'F') { 
                    this.spnyourhisher = 'her' 
                    this.spnyouthey = 'they'
                }
                else { 
                    this.spnyourhisher = '(his/her)' 
                    this.spnyouthey = 'they'
                    this.spnYourTheir = 'their'
                }
            }
            if (this.enrol.RBLBENFE === 'No' && (this.AgentFullName === " " || this.AgentFullName === 'undefined undefined')) { 
                this.spnyourhisher = '(his/her)' 
                this.spnyouthey = 'they'
                this.spnYourTheir = 'their '
            }
        }


    }

    onEthnicityDynamamicChange(value: EthnicityData) {
        var selectedEthnicity: EthnicityData[]

        if (this.enrollmentRaceEthnicityViewModel.Ethnicity == undefined || this.enrollmentRaceEthnicityViewModel.Ethnicity == '') {
            this.ethnicityList.forEach((element, index) => {
                this.enrollmentRaceEthnicityViewModel.Ethnicity =
                    (this.enrollmentRaceEthnicityViewModel.Ethnicity == undefined || this.enrollmentRaceEthnicityViewModel.Ethnicity == '') ? 'N' : this.enrollmentRaceEthnicityViewModel.Ethnicity + 'N'
            });
        }

        var ethnicity = this.enrollmentRaceEthnicityViewModel.Ethnicity.split('')

        if (this.enrollmentRaceEthnicityViewModel.selectedEthnicity == undefined) {
            selectedEthnicity = [];
        }
        else { selectedEthnicity = this.enrollmentRaceEthnicityViewModel.selectedEthnicity }

        if (value.IsChecked) {
            ethnicity[value.DM46Position - 1] = 'Y'
            selectedEthnicity.push(value)
        }
        else {
            ethnicity[value.DM46Position - 1] = 'N'
            selectedEthnicity.forEach((element, index) => {
                if (value.Sequence == element.Sequence) {
                    selectedEthnicity.splice(index, 1);
                }

            });
        }
        this.enrollmentRaceEthnicityViewModel.Ethnicity = ethnicity.join('')
        this.enrollmentRaceEthnicityViewModel.selectedEthnicity = selectedEthnicity
    }

    onRaceDynamamicChange(value: RaceData) {
        var selecteRace: RaceData[]

        if (this.enrollmentRaceEthnicityViewModel.Race == undefined || this.enrollmentRaceEthnicityViewModel.Race == '')  {
            this.raceList.forEach((element, index) => {
                this.enrollmentRaceEthnicityViewModel.Race =
                    (this.enrollmentRaceEthnicityViewModel.Race == undefined || this.enrollmentRaceEthnicityViewModel.Race == '') ? 'N' : this.enrollmentRaceEthnicityViewModel.Race + 'N'
            });
        }

        var race = this.enrollmentRaceEthnicityViewModel.Race.split('')

        if (this.enrollmentRaceEthnicityViewModel.selecteRace == undefined) {
            selecteRace = [];
        }
        else { selecteRace = this.enrollmentRaceEthnicityViewModel.selecteRace }

        if (value.IsChecked) {
            race[value.DM46Position - 1] = 'Y'

            selecteRace.push(value)
        }
        else {
            race[value.DM46Position - 1] = 'N'

            selecteRace.forEach((element, index) => {
                if (value.Sequence == element.Sequence) {
                    selecteRace.splice(index, 1);
                }

            });
        }
        this.enrollmentRaceEthnicityViewModel.Race = race.join('')
        this.enrollmentRaceEthnicityViewModel.selecteRace = selecteRace
    }

    submitEthnicityDynamic(value: string): any {
        if (value == null || value == '') {
            return '';
        }
        var ethnicity = value.split('')
        var selected = false
        ethnicity.forEach((element, index) => {
            if (element == 'Y') {
                selected = true
            }
        });
        if (selected) { return value }
        else { return '' }
    }
    submitRaceDynamic(value: string): any {
        if (value == null || value == '') {
            return '';
        }
        var race = value.split('')
        var selected = false
        race.forEach((element, index) => {
            if (element == 'Y') {
                selected = true
            }
        });
        if (selected) { return value }
        else { return '' }
    }

    selectedRaceDynamicModel(race: RaceData[]): any {
        var displayrace = ''
        if (race != undefined) {
            race.sort((a, b) => (
                a.Sequence - b.Sequence
            ));
            race.forEach((element, index) => {
                if (element.IsChecked) {
                    displayrace = (displayrace == '') ? element.Description : displayrace + ' | ' + element.Description
                }

            });
        }
        return displayrace;
    }
    selectedEthnicityDynamicModel(ethnicity: EthnicityData[]): any {
        var displayEthnicity = ''
        if (ethnicity != undefined) {
            ethnicity.sort((a, b) => (
                a.Sequence - b.Sequence
            ));
            ethnicity.forEach((element, index) => {
                if (element.IsChecked) {
                    displayEthnicity = (displayEthnicity == '') ? element.Description : displayEthnicity + ' | ' + element.Description
                }

            });
        }
        return displayEthnicity;
    }

    selectedEthnicityDynamic(value: string): any {
        var displayEthnicity = ''
        this._enrollmentGateway.getEthnicityData()
            .subscribe(
                (model: EthnicityData[]) => {
                    this.ethnicityList = model
                    var ethnicity = value.split('');
                    this.ethnicityList.sort((a, b) => (
                        a.DM46Position - b.DM46Position
                    ));

                    ethnicity.forEach((element, index) => {
                        if (element == 'Y') {
                            this.ethnicityList[index].IsChecked = true
                        }
                        else {
                            this.ethnicityList[index].IsChecked = false
                        }
                    });

                    this.ethnicityList.sort((a, b) => (
                        a.Sequence - b.Sequence
                    ));

                    this.ethnicityList.forEach((element, index) => {
                        if (element.IsChecked) {
                            displayEthnicity = (displayEthnicity == '') ? element.Description : displayEthnicity + '!' + element.Description
                        }

                    });
                });

        return displayEthnicity;

    }
}